import React, { useContext, useEffect } from "react";
import { fetchAll } from "../utils/fetchResources";
import { AdminSiteContext } from "../contexts/AdminSiteContext";
import { Link } from "react-router-dom";
import clsx from "clsx";
import {
	AppBar,
	Toolbar,
	IconButton,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	makeStyles,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import SettingsIcon from "@material-ui/icons/Settings";
import logo from "../lva-wht-logo.svg";

function TopBar({ drawerWidth, open, setOpen }) {
	const [allSites, setAllSites] = React.useState();
	const { adminSelectedSite, setAdminSelectedSite } =
		useContext(AdminSiteContext);

	const useStyles = makeStyles((theme) => ({
		root: {
			display: "flex",
		},
		appBar: {
			zIndex: theme.zIndex.drawer + 1,
			transition: theme.transitions.create(["width", "margin"], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
		},
		appBarShift: {
			marginLeft: drawerWidth,
			width: `calc(100% - ${drawerWidth}px)`,
			transition: theme.transitions.create(["width", "margin"], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen,
			}),
		},
		menuButton: {
			marginRight: 12,
		},
		siteSelectWrap: {
			minWidth: "150px",
			marginLeft: "1.5rem",
		},
		siteSelectLabel: {
			color: "white",
			marginLeft: ".5rem",
		},
		siteSelect: {
			"& .MuiSelect-root": {
				color: "white",
				background: "rgba(255,255,255,.1)",
			},
			"& .MuiSelect-outlined": {
				color: "white",
				border: "none",
			},
			"& .MuiSelect-iconOutlined": {
				color: "white",
			},
			"& .MuiOutlinedInput-notchedOutline": {
				border: "none",
			},
			"&:hover .MuiOutlinedInput-notchedOutline": {
				border: "none",
			},
		},
		rightToolbar: {
			marginLeft: "auto",
			marginRight: -12,
		},
	}));
	const classes = useStyles();

	useEffect(() => {
		fetchAll("sites", setAllSites, "name");
	}, []);

	const handleDrawerToggle = () => {
		setOpen(!open);
	};

	const handleChangeAdminSelectedSite = (e) => {
		setAdminSelectedSite(e.target.value);
	};

	return (
		<div className={classes.root}>
			<AppBar
				position="fixed"
				className={clsx(classes.appBar, {
					[classes.appBarShift]: open,
				})}
			>
				<Toolbar>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						onClick={handleDrawerToggle}
						edge="start"
						className={clsx(classes.menuButton, {
							[classes.hide]: open,
						})}
					>
						<MenuIcon />
					</IconButton>
					<Link to={`/`} style={{ display: "flex" }}>
						<img
							src={logo}
							style={{ maxHeight: "40px" }}
							alt="LVA Logo Inverted"
						/>
					</Link>
					<FormControl className={classes.siteSelectWrap}>
						<InputLabel
							className={classes.siteSelectLabel}
							id="admin-site-selector-label"
						>
							Site
						</InputLabel>
						<Select
							variant="outlined"
							className={classes.siteSelect}
							labelId="admin-site-selector-label"
							id="admin-site-selector"
							label="Site"
							value={adminSelectedSite ?? ""}
							onChange={handleChangeAdminSelectedSite}
							autoWidth
						>
							<MenuItem value="">All Sites</MenuItem>
							{allSites &&
								allSites.map((site, i) => (
									<MenuItem key={i} value={site}>
										{site.name}
									</MenuItem>
								))}
						</Select>
					</FormControl>
					<section className={classes.rightToolbar}>
						<IconButton
							component={Link}
							to={`/${process.env.REACT_APP_ADMIN_URL}/profile`}
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							color="inherit"
						>
							<SettingsIcon />
						</IconButton>
					</section>
				</Toolbar>
			</AppBar>
		</div>
	);
}

export default TopBar;
